import {Collapse} from 'antd'
import styled from 'styled-components'

export const Root = styled.div``


export const Table = styled.div``

